export const defaultLocale = 'ka' as const;
export const locales = ['ka', 'en'] as const;
export type Locale = (typeof locales)[number];

export const LOCALE_STORAGE_KEY = 'app-locale';

export const LANGUAGE_SWITCHING_ENABLED = false;
